import { useEffect, useRef, useState } from "react";

import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import EditDetailsviewFields from "./EditDetailsviewFields";
import RenderNestedGridLayout from "./RenderNestedGridLayout";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import { elementConfig } from "../../../../utils/Config/DefaultConfig/elementConfig";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import Button from "../../../../components/FormComponents/Button";
import Input from "../../../../components/FormComponents/Input";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import DetailsviewPreview from "../../../../components/BuilderComponents/Preview/DetailsviewPreview";
import { generateObjectId } from "../../../../utils/objectIdUtils";
import { toastError } from "../../../../utils/toastUtils";

const RecordsetListCardDesign = ({
  tableRef,
  layoutData,
  handleSaveRecordsetLayout,
  layoutWidth = "",
  modalType = "recordset-list",
  tableId,
  tableType = "statemachine",
  folderId = [],
  device
}) => {
  const [recordLayout, setRecordLayout] = useState([]);
  const { applicationBlockData } = useAppBlocksContext();
  const recordLayoutData = useRef({});
  const [editElementRightsidebar, setEditElementRightsidebar] = useState({ show: false, id: "" });
  const [fieldsModal, setFieldsModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [width, setWidth] = useState(layoutWidth || 400);
  const handleWidthChange = (e) => {
    const newWidth = e.target.value;
    setWidth(newWidth ? parseInt(newWidth) : 0);
  };

  const editElement = (data) => {
    const object = recordLayoutData.current[data.i];
    const obj = {
      id: object.id,
      type: object.type,
      show: true,
      config: object,
      elements: [applicationBlockData]
    };
    setEditElementRightsidebar(obj);
  };
  const editChangeField = (data) => {
    const nonSupportedField = ["lookup", "lookup-sm", "app-user"];
    if (nonSupportedField.includes(data.field_type)) {
      setIsModalOpen({ type: "" });
      toastError("Can not use field");
      return;
    }
    let i = isModalOpen.i;
    const newLayoutData = JSON.parse(JSON.stringify(recordLayoutData.current));

    const newData = { ...newLayoutData[i], ...data };
    newData.prefix = data.prefix || "";

    newLayoutData[i] = newData;
    recordLayoutData.current = newLayoutData;
    setIsModalOpen({ type: "" });
    setRecordLayout([...recordLayout]);
  };

  const saveElement = (config) => {
    const newLayoutData = JSON.parse(JSON.stringify(recordLayoutData.current));
    newLayoutData[config.i] = config;
    recordLayoutData.current = newLayoutData;
    setRecordLayout([...recordLayout]);
  };

  const calculateGrid = () => {
    const newID = generateObjectId();
    let maxY = 0;
    recordLayout.forEach((element) => {
      if (element.y > maxY) {
        maxY = element.y;
      }
    });

    const grid = {
      w: 12,
      h: 2,
      x: 0,
      y: maxY + 1,
      i: newID
    };
    return { newID, grid };
  };

  const addField = (data) => {
    const { newID, grid } = calculateGrid();
    const newData = {
      ...data,
      i: newID,
      className: {},
      inline_style: {},
      icon: "",
      colorif: [],
      custom_css: ""
    };
    recordLayoutData.current[newID] = newData;
    setRecordLayout([...recordLayout, grid]);
  };
  const addStaticData = (key) => {
    const { newID, grid } = calculateGrid();
    const commonConfig = {
      i: newID,
      id: newID,
      className: {},
      inline_style: {},
      icon: "",
      colorif: [],
      custom_css: ""
    };

    // let newData = {};

    const eleConfig = elementConfig[key];
    const newData = { ...commonConfig, ...eleConfig };

    recordLayoutData.current[newID] = newData;
    setRecordLayout((prevRecordLayout) => [...prevRecordLayout, grid]);
  };

  const handleSaveRecordlistGrid = () => {
    const newList = recordLayout.map((record) => {
      return {
        grid: record,
        element_config: recordLayoutData.current[record.i]
      };
    });
    if (modalType === "rich-column") {
      handleSaveRecordsetLayout({ layouts: newList, layout_width: width });
    } else {
      handleSaveRecordsetLayout(newList);
    }
    // handleSaveRecordsetLayout(newList);
  };

  const handleModalAction = (response) => {
    if (response.type === "edit" || response.type === "tableview") {
      editElement(response);
    }
    if (response.type === "add" || response.type === "change") {
      setIsModalOpen(response);
    }
  };
  useEffect(() => {
    //doing intial rendering for filtering fields
    // const currentLayout = layoutData.current[i][keyName]?.layouts || [];
    const allowedStaticElements = ["label", "spacer", "separator", "button", "html", "progress-tracker"];
    const newGrid = layoutData
      .filter((lay) => {
        // If type is 'label', let it be true
        if (allowedStaticElements.includes(lay.element_config.type)) {
          return true;
        }
        // Run for fields
        return tableRef.current[lay.element_config.id];
      })
      .map((record) => {
        recordLayoutData.current[record.grid.i] = {
          ...record.element_config,
          ...tableRef.current[record.element_config.id]
        };
        return record.grid;
      });
    setRecordLayout(newGrid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const typeBasedSize = (type) => {
    switch (type) {
      case "button-group":
        return "large";
      case "html":
      case "dynamic-html":
        return "medium";
      default:
        return "small";
    }
  };
  useEffect(() => {
    const newList = recordLayout.map((record) => {
      return {
        grid: record,
        element_config: recordLayoutData.current[record.i]
      };
    });
    setPreviewData(newList);
  }, [recordLayout]);

  return (
    <div className="h_80_vh" style={{ width: "55vw" }}>
      <BuilderTabs
        containerClass={"rich_cell_tabs"}
        tabs={[
          {
            label: "Layout",
            content: (
              <>
                <div className="justify_between w_100 d_flex" style={{ marginTop: "36px" }}>
                  <div className="d_flex gap_3 align_center flex_wrap">
                    {/* <Button variant="secondary" onClick={() => setFieldsModal(true)}>
                      Add Field
                    </Button> */}
                    <div className="d_flex align_center gap_2">
                      <label className="builder_label w_auto mb_0">Add Field</label>
                      <ButtonActionIcon type="add" size="xsm" onClick={() => setFieldsModal(true)} />
                    </div>

                    {["label", "spacer", "separator", "button", "html", "progress-tracker"].map((field) => (
                      <div className="d_flex align_center gap_2" key={field}>
                        <label key={field} className="builder_label w_auto mb_0">
                          {field}
                        </label>
                        <ButtonActionIcon type="add" size="xsm" onClick={() => addStaticData(field)} />
                      </div>
                    ))}
                  </div>
                  <Button onClick={handleSaveRecordlistGrid}>Save</Button>
                </div>
                {/* <div className="w_50"></div> */}

                {modalType === "rich-column" && (
                  <div>
                    <Input
                      label="Editing Layout Width (in px): "
                      type="number"
                      id="widthInput"
                      value={width}
                      onChange={handleWidthChange}
                      placeholder="Enter width in px"
                      containerStyle={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px",
                        width: "300px",
                        marginTop: "10px",
                        marginBottom: "10px"
                      }}
                    />
                  </div>
                )}
                <div className="d_flex justify_center">
                  <div
                    style={
                      modalType === "rich-column"
                        ? {
                            width: `${width}px`,
                            transition: "width 0.3s ease",
                            border: "1px dashed #dadce0",
                            padding: "12px",
                            height: "60vh",
                            maxWidth: "55vw"
                          }
                        : {
                            width: "100%",
                            border: "1px dashed #dadce0",
                            padding: "12px",
                            height: "60vh",
                            maxWidth: "55vw"
                          }
                    }
                  >
                    <RenderNestedGridLayout
                      layoutData={recordLayoutData}
                      tableRef={tableRef}
                      layout={recordLayout}
                      setLayout={setRecordLayout}
                      isDroppable={false}
                      handleModalAction={handleModalAction}
                      tableID={tableId}
                      device={device}
                    />
                  </div>
                </div>
                <BuilderRightSideBar
                  isOpen={editElementRightsidebar.show}
                  onClose={() => setEditElementRightsidebar({ show: false, id: "" })}
                  heading={editElementRightsidebar.type}
                  size={typeBasedSize(editElementRightsidebar.type)}
                >
                  <EditDetailsviewFields
                    editElementRightsidebar={editElementRightsidebar}
                    saveElement={saveElement}
                    smId={tableId}
                    tableType={tableType}
                    device={device}
                  />
                </BuilderRightSideBar>
                <BuilderModal isOpen={fieldsModal} onClose={() => setFieldsModal(false)} modalName="Select Field">
                  <TableTreeModal callbackFunction={addField} tableId={tableId} folderId={folderId} />
                </BuilderModal>

                <BuilderModal
                  isOpen={isModalOpen.type}
                  onClose={() => setIsModalOpen({ type: "" })}
                  modalName={isModalOpen.modal_name}
                >
                  {isModalOpen.type === "change" && (
                    <TableTreeModal
                      callbackFunction={editChangeField}
                      tableId={tableId}
                      // folderId={activityID ? [activityID, "global_fields"] : []}
                      folderId={[]}
                      selectedFile={isModalOpen.type === "change" ? recordLayoutData.current[isModalOpen.i]?.id : ""}
                    />
                  )}
                </BuilderModal>
              </>
            )
          },
          {
            label: "Preview",
            content: (
              <div className="justify_between w_100 d_flex" style={{ marginTop: "36px" }}>
                <DetailsviewPreview detailviewConfig={previewData} />
              </div>
            )
          }
        ]}
      />
    </div>
  );
};

export default RecordsetListCardDesign;
